const getUrl = require('bmh/url-with-param');

export function insertScript(src: string, is_async?: boolean): HTMLElement {
  const script = document.createElement('script');
  if (is_async) {
    script.async = true;
  }
  script.defer = true;
  script.src = src;
  const S = document.getElementsByTagName('body')[0];
  S.insertBefore(script, S.nextSibling);
  return script;
}

export function trim(str: string, chars: string): string {
  const regExp = `^(${chars})+|(${chars})+$`;
  return str.replace(new RegExp(regExp, 'g'), '');
}

export function redirect(url: string): string {
  if (process.env.VUE_APP_ENV) {
    return getUrl(url, {
      'x-tugou-stage': process.env.VUE_APP_ENV,
    });
  }
  return url;
}
